import { render } from "./StatusBanner.vue?vue&type=template&id=7ec581e3"
import script from "./StatusBanner.vue?vue&type=script&lang=js"
export * from "./StatusBanner.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_d537e74c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__